package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Stage
import io.horion.cv.components.widgets.DateRangeSelector
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.RichTextDescription
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.models.StageState
import io.horion.cv.styles.ActivityFullWidthFieldStyle
import io.horion.cv.styles.ActivityHalfWidthFieldStyle
import org.jetbrains.compose.web.css.px

@Composable
fun InternshipForm(
    index: Int,
    state: StageState,
    cvViewModel: CvViewModel,
    onDelete: () -> Unit,
    onComplete: () -> Unit
) {
    val updateVM = {
        val updatedStage = Stage(
            post = state.poste,
            enterprise = state.employeur,
            city = state.ville,
            started = "${state.moisDebut}-${state.anneeDebut}",
            ended = if (state.isOngoing) "En cours" else "${state.moisFin}-${state.anneeFin}",
            description = state.description
        )
        cvViewModel.updateStage(index, updatedStage)
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(25.px)
    ) {
        TextFormField(
            label = "Poste",
            value = state.poste,
            onValueChange = {
                state.poste = it
                updateVM()
            },
            modifier = Modifier.fillMaxWidth()
        )

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .displayUntil(Breakpoint.MD)) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(16.px)
            ) {
                TextFormField(
                    label = "Employeur",
                    value = state.employeur,
                    onValueChange = {
                        state.employeur = it
                        updateVM()
                    },
                    modifier = ActivityFullWidthFieldStyle.toModifier()
                )
                TextFormField(
                    label = "Ville",
                    value = state.ville,
                    onValueChange = {
                        state.ville = it
                        updateVM()
                    },
                    modifier = ActivityFullWidthFieldStyle.toModifier()
                )
            }
        }

        // --- LAYOUT DESKTOP / TABLETTE (>= MD) ---
        Box(modifier = Modifier.fillMaxWidth().displayIfAtLeast(Breakpoint.MD)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(25.px)
            ) {
                TextFormField(
                    label = "Employeur",
                    value = state.employeur,
                    onValueChange = {
                        state.employeur = it
                        updateVM()
                    },
                    modifier = ActivityHalfWidthFieldStyle.toModifier()
                )
                TextFormField(
                    label = "Ville",
                    value = state.ville,
                    onValueChange = {
                        state.ville = it
                        updateVM()
                    },
                    modifier = ActivityHalfWidthFieldStyle.toModifier()
                )
            }
        }

        DateRangeSelector(
            startMonth = state.moisDebut,
            startYear = state.anneeDebut,
            endMonth = state.moisFin,
            endYear = state.anneeFin,
            isOngoing = state.isOngoing,
            onStartMonthChange = { state.moisDebut = it; updateVM() },
            onStartYearChange = { state.anneeDebut = it; updateVM() },
            onEndMonthChange = { state.moisFin = it; updateVM() },
            onEndYearChange = { state.anneeFin = it; updateVM() },
            onOngoingChange = {
                state.isOngoing = it
                if (it) {
                    state.moisFin = ""
                    state.anneeFin = ""
                }
                updateVM()
            }
        )

        RichTextDescription(
            label = "Description",
            value = state.description,
            onValueChange = {
                state.description = it
                updateVM()
            },
            modifier = Modifier.fillMaxWidth()
        )

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}